import React, { useEffect, useState, useRef } from "react";
import "./Preguntas.css";
import "@fontsource/fira-sans";
import "@fontsource/fira-sans/700.css";
import "@fontsource/fira-sans/500.css";
import "@fontsource/fira-sans/400-italic.css";
import "@fontsource/fira-sans/200.css";

function Preguntas() {
  const [text, setText] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const cachedText = localStorage.getItem("cachedText");
    if (cachedText) {
      setText(cachedText);
      setSearchQuery(cachedText.toLowerCase());
    }
  }, []);

  const collapses = [
    {
      id: "collapse1",
      question: "¿Es seguro recibir anestesia?",
      answer:
        "¡Claro! Recibir anestesia es seguro en la mayoría de los casos porque está diseñada específicamente para que no sientas dolor durante un procedimiento médico. Además,siempre es administrada y supervisada por un profesional especializado (anestesiólogo) que se encarga de cuidar que todo salga bien",
    },
    {
      id: "collapse2",
      question: "¿Voy a despertar después de la cirugía?",
      answer:
        "Es una duda muy frecuente y completamente normal, cuando termina el procedimiento, el anestesiólogo deja de administrarte los medicamentos que te mantienen dormido. Tu cuerpo comienza a eliminarlos de manera natural, y poco a poco vuelves a despertarte.",
    },
    {
      id: "collapse3",
      question: "¿Es posible no despertar? ",
      answer:
        "Es extremadamente raro que alguien no despierte después de una anestesia, y suele estar relacionado con problemas de salud preexistentes, no con la anestesia misma. Antes del procedimiento, el anestesiólogo revisa cuidadosamente tu historia médica para minimizar cualquier riesgo.",
    },
    {
      id: "collapse4",
      question: "¿Puedo despertarme durante la cirugía? ",
      answer:
        'En términos médicos, esto se llama "conciencia intraoperatoria", y sucede cuando una persona se da cuenta de lo que está pasando durante un procedimiento bajo anestesia general. Sin embargo, esto es extremadamente raro, gracias a los avances en la medicinay a la vigilancia constante de los anestesiólogos.',
    },
    {
      id: "collapse5",
      question: "¿Qué efectos secundarios puedo experimentar? ",
      answer:
        "Como con cualquier tratamiento, existen riesgos, pero son mínimos cuando estás en manos de un experto. Los efectos secundarios más comunes son: \n-Mareo o náuseas después del procedimiento. \n-Somnolencia o cansancio temporal. \n-Reacciones leves, como picazón o enrojecimiento. \nEn casos raros, pueden ocurrir complicaciones más serias, pero por eso se toman todas las precauciones antes, durante y después de la anestesia.",
    },
    {
      id: "collapse6",
      question: "¿Qué pasa si tengo una reacción alérgica a la anestesia? ",
      answer:
        "Es muy poco común. Antes de la cirugía, el anestesiólogo te hace preguntas sobre alergias conocidas, medicamentos que tomas y experiencias previas con anestesia. Esto ayuda a evitar usar un medicamento que pueda causar una reacción. \nSi llegas a tener una reacción alérgica, el equipo médico la controlará en el momento. Después, evaluarán qué medicamento la causó y te darán instrucciones claras para evitarlo en el futuro. \nEn resumen, aunque es posible tener una reacción alérgica, el riesgo es muy bajo y el equipo médico está preparado para manejar cualquier situación.",
    },
    {
      id: "collapse7",
      question: "¿Voy a sentir dolor durante o después del procedimiento? ",
      answer:
        "Durante la cirugía se controla el dolor con medicamentos, posterior al procedimiento, depende del tipo de cirugía pueden o no existir molestías, se te darán los medicamentos necesarios para minimizar al máximo tus molestias.",
    },
    {
      id: "collapse8",
      question: "¿Qué tipo de anestesia voy a recibir? ",
      answer:
        "Depende del tipo de procedimiento y de si el paciente es sano o con alguna enfermedad.",
    },
    {
      id: "collapse9",
      question: "¿Cuánto tiempo estaré bajo anestesia? ",
      answer:
        "Un poco más de lo que dura la cirugía, previo 10 a 30 minutos y al terminar 10 a 15 minutos más.",
    },
    {
      id: "collapse10",
      question: "¿Qué tan calificado está el anestesiólogo? ",
      answer:
        "El anestesiólogo cuenta con 7 años de medicina general, 3 de especialidad y 1 a 3 de subespecialidad.",
    },
    {
      id: "collapse11",
      question: "¿Qué puedo hacer para prepararme? ",
      answer:
        "Asegúrate de hablar abiertamente con el anestesiólogo, informar sobre tu salud y seguir sus indicaciones. Esto ayuda a reducir riesgos y asegura que la anestesia funcione perfectamente.",
    },
    {
      id: "collapse12",
      question: "¿Puedo tomar alcohol? ",
      answer:
        "No, puede hacer que sea más difícil ajustar la dosis correcta, tu hígado procesa tanto el alcohol como los medicamentos anestésicos, lo que puede interferir con la forma en que elimina los medicamentos de tu cuerpo. Es recomendable <strong>evitar el alcohol por lo menos 24 horas antes</strong> de la anestesia. Si el procedimiento es más grande o requiere anestesia general, algunos médicos sugieren evitarlo durante varios días antes.",
    },
    {
      id: "collapse13",
      question: "¿Puedo fumar marihuana? ",
      answer:
        "No, puede tener efectos en la respiración, interacción con medicamentos, asi como sobre el corazón y la presión arterial, náusea y vómito. Es recomendable no consumirla al menos 7 días antes del procedimiento, entre más días pasan, más se reduce el riesgo.",
    },
    {
      id: "collapse14",
      question: "¿Qué pasa si he fumado marihuana recientemente? ",
      answer:
        "<strong>Informa al anestesiólogo.</strong> Esto es crucial. Ellos no están para juzgarte, sino para garantizar tu seguridad. Saber que has consumido marihuana les ayuda a ajustar los medicamentos y a tomar precauciones adicionales.",
    },
    {
      id: "collapse15",
      question: "¿Puedo tomar mis medicamentos el día de la cirugía ?  ",
      answer:
        "Es importante platicar tanto con tu cirujano como con tu anestesiólogo a cerca de los medicamentos que consumes de manera regular, en conjunto y basado en tu padecimiento, te indicarán si continuar o no. Te dejamos una lista de medicamentos que es importante notificar si consumes:",
    },
    {
      id: "collapse16",
      question: "¿Me puedo desvelar? ",
      answer: "Si, no hay contraindicación.",
    },
    {
      id: "collapse17",
      question: "¿Puedo tomar mis medicamentos para la ansiedad? ",
      answer:
        "Si, tomalos como lo haces regularmente, posterior a tu cirugía se pueden reiniciar con autorización de tu médico.",
    },
    {
      id: "collapse18",
      question:
        "¿Cómo se garantiza la seguridad del procedimiento anestésico? ",
      answer:
        "<strong>Evaluación previa</strong>: Antes del procedimiento, el anestesiólogo revisa tu historia médica, alergias, medicamentos que tomas y si tienes alguna condición especial (como presión alta, diabetes, etc). Esto ayuda a elegir el tipo de anestesia más adecuado para ti. <br><strong>Supervisión constante</strong>: Durante el procedimiento, te monitorean de cerca con equipos que controlan tu ritmo cardíaco, presión arterial, respiración, ondas cerebrales, etc. Si algo cambia, el anestesiólogo actúa de inmediato. <br><strong>Anestesia personalizada</strong>: La dosis y el tipo de anestesia se ajustan específicamente a tus necesidades. Hay diferentes tipos y el médico elige el más seguro y efectivo para el procedimiento que necesitas.",
    },
  ];

  const filteredCollapses = collapses.filter((collapse) =>
    collapse.question.toLowerCase().includes(searchQuery)
  );

  const [collapsedStates, setCollapsedStates] = useState(
    Object.fromEntries(collapses.map((c) => [c.id, true]))
  );

  const toggleCollapse = (key) => {
    setCollapsedStates((prevStates) => ({
      ...prevStates,
      [key]: !prevStates[key],
    }));
  };

  const collapse15 = collapses.find((c) => c.id === "collapse15");

  const modalContentRef = useRef(null);

  const handleClickOutsideModal = (event) => {
    if (
      modalContentRef.current &&
      !modalContentRef.current.contains(event.target)
    ) {
      setShowModal(false);
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1 style={titlePreguntas}>Preguntas frecuentes</h1>

      <div className="container">
        <div className="buscador">
          <i className="fa fa-search" aria-hidden="true"></i>
          <input
            type="text"
            value={text}
            onChange={(e) => {
              const inputValue = e.target.value;
              setText(inputValue);
              setSearchQuery(inputValue.toLowerCase());
            }}
            placeholder="Resolvemos tus dudas en un minuto"
          />
        </div>
      </div>

      {filteredCollapses.map((collapse) => (
        <div
          key={collapse.id}
          className={`cntPreguntasFrecuentes ${
            collapsedStates[collapse.id] ? "collapsed" : "expanded"
          }`}
        >
          <button onClick={() => toggleCollapse(collapse.id)}>
            <span className="styleQuestion">Q</span>
            {collapse.question}{" "}
            {collapsedStates[collapse.id] ? (
              <i className="styleIcon fa-solid fa-plus fa-lg"></i>
            ) : (
              <i className="styleIcon fa-solid fa-minus fa-lg"></i>
            )}
          </button>
          <div
            style={{
              maxHeight: collapsedStates[collapse.id] ? "0" : "400px",
              overflow: "hidden",
              transition: "max-height 0.2s ease",
            }}
            className={`cntRespuesta ${
              collapsedStates[collapse.id] ? "collapsed" : "expanded"
            }`}
          >
            <span className="styleAnswer">R</span>
            <div className="styleRespuesta">
              <div
                dangerouslySetInnerHTML={{
                  __html: collapse.answer.replace(/\n/g, "<br />"),
                }}
              />
              {collapse.id === "collapse15" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "10px",
                  }}
                >
                  <button
                    onClick={() => setShowModal(true)}
                    style={{
                      backgroundColor: "#134074",
                      color: "white",
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "5px",
                      width: "fit-content",
                    }}
                  >
                    Ver lista de medicamentos
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}

      {showModal && (
        <div
          onClick={handleClickOutsideModal}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            ref={modalContentRef}
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "10px",
              maxWidth: "600px",
              width: "90%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <h2 style={{ color: "#134074" }}>
              Lista de medicamentos importantes
            </h2>
            <div
              style={{ textAlign: "left", fontSize: "14px", marginTop: "15px" }}
            >
              <p>
                Estos son algunos de los medicamentos que debes notificar si
                consumes:
              </p>
              <ul>
                <li>
                  <strong>
                    <u>Inhibidores GLP-1</u>
                  </strong>
                  : Ozempic®, Wegovy®, Trulicity®, Victoza®, Saxenda®, Byetta®,
                  Bydureon®, Mounjaro®
                </li>
                <li>
                  <strong>
                    <u>Antihipertensivos</u>
                  </strong>
                  :
                  <ul>
                    <li>
                      <strong>Captopril</strong>: Capoten®, Acetensa®,
                      Capotenil®
                    </li>
                    <li>
                      <strong>Enalapril</strong>: Renitec®, Enalap®, Novatec®
                    </li>
                    <li>
                      <strong>Lisinopril</strong>: Prinivil®, Zestril®, Lisinol®
                    </li>
                    <li>
                      <strong>Ramipril</strong>: Tritace®, Altace®
                    </li>
                    <li>
                      <strong>Perindopril</strong>: Coversyl®, Perindox®
                    </li>
                    <li>
                      <strong>Quinapril</strong>: Accupril®
                    </li>
                    <li>
                      <strong>Losartán</strong>: Cozaar®, Loten®, Aradois®
                    </li>
                    <li>
                      <strong>Valsartán</strong>: Diovan®, Vals®, Vartan®
                    </li>
                    <li>
                      <strong>Irbesartán</strong>: Aprovel®, Irtan®, Irbez®
                    </li>
                    <li>
                      <strong>Candesartán</strong>: Atacand®, Candez®
                    </li>
                    <li>
                      <strong>Olmesartán</strong>: Benicar®, Olmetec®
                    </li>
                    <li>
                      <strong>Telmisartán</strong>: Micardis®, Temisán®
                    </li>
                    <li>
                      <strong>Eprosartán</strong>: Teveten®
                    </li>
                    <li>
                      <strong>Combinaciones</strong>:
                      <ul>
                        <li>
                          <strong>Losartán + Hidroclorotiazida</strong>: Cozaar
                          Plus®, Lopresor H®
                        </li>
                        <li>
                          <strong>Valsartán + Hidroclorotiazida</strong>: Diovan
                          HCT®
                        </li>
                        <li>
                          <strong>Enalapril + Hidroclorotiazida</strong>:
                          Renitec D®
                        </li>
                        <li>
                          <strong>Telmisartán + Hidroclorotiazida</strong>:
                          Micardis Plus®
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>
                    <u>Anticoagulantes</u>
                  </strong>
                  :
                  <ul>
                    <li>
                      <strong>Warfarina</strong>: Coumadin®, Aldocumar®
                    </li>
                    <li>
                      <strong>Enoxaparina</strong>: Clexane®, Lovenox®
                    </li>
                    <li>
                      <strong>Dalteparina</strong>: Fragmin®
                    </li>
                    <li>
                      <strong>Nadroparina</strong>: Fraxiparina®
                    </li>
                    <li>
                      <strong>Heparina sódica</strong>: Liquemine®
                    </li>
                    <li>
                      <strong>Fondaparinux</strong>: Arixtra®
                    </li>
                    <li>
                      <strong>Argatrobán</strong>: Argatroban®
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>
                    <u>Antiplaquetarios</u>
                  </strong>
                  :
                  <ul>
                    <li>
                      <strong>Ácido Acetilsalicílico (Aspirina)</strong>:
                      Aspirina®, Aspec®, Acel®, Cardioaspirina®, Bufferin®,
                      Aspro®
                    </li>
                    <li>
                      <strong>Clopidogrel</strong>: Plavix®, Clopidogrel®,
                      Iscover®
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <button
              onClick={() => setShowModal(false)}
              style={{
                marginTop: "20px",
                backgroundColor: "#134074",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "5px",
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const titlePreguntas = {
  fontFamily: "'Fira Sans', sans-serif",
  fontSize: "48px",
  color: "#134074",
  fontWeight: 900,
};

export default Preguntas;
